import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Services = () => {
  const { t } = useLanguage();
  const includes = (t("services", "includes") as Array<{ title: string; desc: string }>) || [];
  const investmentItems = (t("services", "investmentItems") as string[]) || [];

  return (
    <section id="servicios" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t("services", "title")}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            {t("services", "tagline")}
          </p>
          <div className="w-24 h-1 bg-gold mx-auto mt-6"></div>
        </div>

        <div className="max-w-4xl mx-auto mb-20 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
            {t("services", "introTitle")}
          </h3>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {t("services", "introDesc")}
          </p>
        </div>

        <div className="mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-10 text-center">
            {t("services", "includesTitle")}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {includes.map((item, index) => (
              <Card
                key={index}
                className={`p-6 h-full hover:shadow-xl transition-all duration-300 ${
                  index === includes.length - 1 ? "md:col-span-2 lg:col-span-3" : ""
                }`}
              >
                <h4 className="text-xl font-bold text-foreground mb-3">{item.title}</h4>
                <p className="text-muted-foreground leading-relaxed">{item.desc}</p>
              </Card>
            ))}
          </div>
        </div>

        <div className="mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-10 text-center">
            {t("services", "structureTitle")}
          </h3>
          <div className="grid lg:grid-cols-2 gap-8">
            <Card className="p-8 h-full hover:shadow-xl transition-all duration-300">
              <span className="text-sm font-semibold text-gold uppercase tracking-wide">
                {t("services", "session1Duration")}
              </span>
              <h4 className="text-2xl font-bold text-foreground mt-2 mb-4">
                {t("services", "session1Title")}
              </h4>
              <p className="text-muted-foreground leading-relaxed">
                {t("services", "session1Desc")}
              </p>
            </Card>
            <Card className="p-8 h-full hover:shadow-xl transition-all duration-300">
              <span className="text-sm font-semibold text-gold uppercase tracking-wide">
                {t("services", "session2Duration")}
              </span>
              <h4 className="text-2xl font-bold text-foreground mt-2 mb-4">
                {t("services", "session2Title")}
              </h4>
              <p className="text-muted-foreground leading-relaxed">
                {t("services", "session2Desc")}
              </p>
            </Card>
          </div>
        </div>


        <div className="bg-gradient-to-r from-espresso to-warmBrown rounded-2xl p-10 md:p-14 text-center mb-8">
          <h3 className="text-2xl md:text-3xl font-bold text-cream mb-4">
            {t("services", "investmentTitle")}
          </h3>
          <div className="max-w-2xl mx-auto text-left mb-8">
            <p className="text-cream font-semibold mb-3">{t("services", "investmentIncludesTitle")}</p>
            <ul className="space-y-2 mb-6">
              {investmentItems.map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-cream/90">
                  <CheckCircle className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-cream/80 text-sm leading-relaxed mb-2">{t("services", "investmentTravel")}</p>
            <p className="text-cream/80 text-sm leading-relaxed mb-2">{t("services", "investmentExtras")}</p>
            <p className="text-cream/80 text-sm leading-relaxed">{t("services", "investmentDisclaimer")}</p>
          </div>
          <p className="text-cream/90 text-lg italic max-w-3xl mx-auto mb-8">
            {t("services", "closingLine")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="gold" size="lg" asChild>
              <a href="#contacto">{t("services", "ctaButton")}</a>
            </Button>
            <Button variant="outline" size="lg" asChild className="bg-transparent border-cream/40 text-cream hover:bg-cream/10 hover:text-cream">
              <a href="/consultoria-apertura-cafeterias">Consultoría para abrir tu cafetería</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
